
















import Vue from "vue";
import Component from "vue-class-component";
import * as store from "../plugins/store";
import { i18n } from "../plugins/i18n";

@Component
export default class Navbar extends Vue {
  get locales() {
    return [{ icon: "🇸🇦", code: "ar" }, { icon: "🇺🇸", code: "en" }, { icon: "🇷🇺", code: "ru" }];
  }
  get currentLocale() {
    for (const locale of this.locales) {
      if (locale.code === i18n.locale) {
        return locale;
      }
    }
  }
  changeLanguage(locale: string) {
    i18n.locale = locale;
    store.setLanguage(locale);
    if (locale == "ar") {
      this.$vuetify.rtl = true
    } else {
      this.$vuetify.rtl = false
    }
    document.title = i18n.t("title") as string;
  }
}
